import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import Ground from 'src/views/Pages/Dashboard/Ground/Ground/Ground.vue';
import GroundNutrients from 'src/views/Pages/Dashboard/Ground/GroundNutrients/GroundNutrients.vue';
import GroundRange from 'src/views/Pages/Dashboard/Ground/Range/Range.vue';
import GroundRangeCreateEdit from 'src/views/Pages/Dashboard/Ground/Range/RangeGroundCreateEdit.vue';
import GroundReport from 'src/views/Pages/Dashboard/Ground/Reports/Reports.vue';
import Types from 'src/views/Pages/Dashboard/Ground/Types/Index.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';

const GroundRoutes = {
  path: 'grounds',
  component: MasterTab,
  props: { reference: 'groundsTabs' },
  children: [
    {
      path: 'nutrients',
      name: 'samples.grounds',
      component: GroundNutrients,
      meta: {
        prefix_permission: 'grounds_nutrients',
      },
    },
    {
      path: 'ranges',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'samples.grounds',
          component: GroundRange,
          meta: {
            prefix_permission: 'grounds_ranges',
          },
        },
        {
          path: 'create',
          name: 'samples.grounds',
          component: GroundRangeCreateEdit,
          meta: {
            prefix_permission: 'grounds_ranges',
          },
        },
        {
          path: 'edit',
          name: 'samples.grounds',
          component: GroundRangeCreateEdit,
          meta: {
            prefix_permission: 'grounds_ranges',
          },
        },
      ],
    },
    {
      path: 'grounds',
      name: 'samples.grounds',
      component: Ground,
      meta: {
        prefix_permission: 'grounds_grounds',
      },
    },
    {
      path: 'reports',
      name: 'samples.grounds',
      component: GroundReport,
      meta: {
        prefix_permission: 'grounds_reports',
      },
    },
    {
      path: 'types',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'samples.grounds',
          component: Types,
          meta: {
            prefix_permission: 'grounds_types',
          },
        },
        {
          path: 'create',
          name: 'Suelos',
          component: GroundRangeCreateEdit,
          meta: {
            prefix_permission: 'grounds_types',
          },
        },
        {
          path: 'edit',
          name: 'Suelos',
          component: GroundRangeCreateEdit,
          meta: {
            prefix_permission: 'grounds_types',
          },
        },
      ],
    },
  ],
};

export default GroundRoutes;
